/* eslint-disable */
import React, { useState, useEffect, useRef } from 'react';

export default function ExitPopup({ page }) {
  const [visible, setVisible]       = useState(false);
  const [dismissed, setDismissed]   = useState(false);
  const [priceNight, setPriceNight] = useState(150);
  const [nights, setNights]         = useState(20);
  const [email, setEmail]           = useState('');
  const [reason, setReason]         = useState('');
  const [loading, setLoading]       = useState(false);
  const [sent, setSent]             = useState(false);
  const [isMobile]                  = useState(window.innerWidth < 768);
  const shownRef                    = useRef(false);

  const base    = priceNight * nights;
  const airbnb  = Math.round(base * 0.155);
  const havenly = Math.round(base * 0.08);
  const gain    = airbnb - havenly;

  useEffect(() => {
    if (shownRef.current) return;
    const sessionKey = 'havenly_exit_popup_shown';
    if (sessionStorage.getItem(sessionKey)) return;

    const handleMouseLeave = (e) => {
      if (e.clientY <= 10 && !shownRef.current) {
        shownRef.current = true;
        sessionStorage.setItem(sessionKey, '1');
        setTimeout(() => setVisible(true), 200);
      }
    };

    let lastScrollY = window.scrollY;
    let lastScrollTime = Date.now();
    const handleScroll = () => {
      const now = Date.now();
      const delta = window.scrollY - lastScrollY;
      const timeDelta = now - lastScrollTime;
      if (delta < -80 && timeDelta < 300 && window.scrollY < 200 && !shownRef.current) {
        shownRef.current = true;
        sessionStorage.setItem(sessionKey, '1');
        setTimeout(() => setVisible(true), 200);
      }
      lastScrollY = window.scrollY;
      lastScrollTime = now;
    };

    document.addEventListener('mouseleave', handleMouseLeave);
    if (isMobile) window.addEventListener('scroll', handleScroll, { passive: true });
    return () => {
      document.removeEventListener('mouseleave', handleMouseLeave);
      if (isMobile) window.removeEventListener('scroll', handleScroll);
    };
  }, [isMobile]);

  const handleDismiss = () => { setDismissed(true); setVisible(false); };

  const handleSubmit = async () => {
    setLoading(true);
    try {
      await fetch('/api/send-email', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          type: 'exit_popup',
          to: 'contact@havenly.fr',
          data: {
            email: email || 'Non renseigne',
            reason: reason || 'Non renseigne',
            priceNight,
            nights,
            gainMensuel: gain,
            page,
            date: new Date().toLocaleString('fr-FR', { day: 'numeric', month: 'long', year: 'numeric', hour: '2-digit', minute: '2-digit' }),
          }
        })
      });
    } catch (e) {}
    setSent(true);
    setTimeout(() => handleDismiss(), 2500);
    setLoading(false);
  };

  if (!visible || dismissed) return null;

  return (
    <>
      <div onClick={handleDismiss} style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', zIndex: 99998 }} />
      <div style={{ position: 'fixed', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', zIndex: 99999, width: isMobile ? 'calc(100vw - 32px)' : 480, maxHeight: '90vh', overflowY: 'auto', background: 'var(--white)', borderRadius: 20, boxShadow: '0 20px 60px rgba(0,0,0,0.2)', border: '1px solid var(--border)' }}>

        {sent ? (
          <div style={{ padding: '3rem 2rem', textAlign: 'center' }}>
            <div style={{ width: 56, height: 56, borderRadius: '50%', background: '#E1F5EE', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 16px' }}>
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#0F6E56" strokeWidth="2"><polyline points="20 6 9 17 4 12"/></svg>
            </div>
            <h3 style={{ fontFamily: 'var(--serif)', fontSize: 20, marginBottom: 8 }}>Merci !</h3>
            <p style={{ fontSize: 14, color: 'var(--ink-3)', lineHeight: 1.6 }}>Votre message a bien ete recu. Matthieu vous contactera bientot.</p>
          </div>
        ) : (
          <div style={{ padding: isMobile ? '1.5rem' : '2rem' }}>

            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 20 }}>
              <div>
                <div style={{ display: 'inline-flex', alignItems: 'center', gap: 6, background: '#FCEBEB', border: '1px solid #F09595', borderRadius: 20, padding: '4px 12px', marginBottom: 10 }}>
                  <span style={{ fontSize: 11, color: '#A32D2D', fontWeight: 500 }}>Avant de partir</span>
                </div>
                <h3 style={{ fontFamily: 'var(--serif)', fontSize: isMobile ? 18 : 22, letterSpacing: '-0.5px', margin: 0, lineHeight: 1.2 }}>
                  Combien perdez-vous sur Airbnb chaque mois ?
                </h3>
              </div>
              <button onClick={handleDismiss} style={{ background: 'var(--surface)', border: '1px solid var(--border)', borderRadius: '50%', width: 32, height: 32, display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer', flexShrink: 0, marginLeft: 12 }}>
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="var(--ink-3)" strokeWidth="2"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
              </button>
            </div>

            <div style={{ background: 'var(--surface)', borderRadius: 14, padding: 16, marginBottom: 16 }}>
              <div style={{ marginBottom: 14 }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: 12, marginBottom: 5 }}>
                  <span style={{ color: 'var(--ink-3)' }}>Prix par nuit</span>
                  <span style={{ fontWeight: 500, color: 'var(--ink)' }}>{priceNight} €</span>
                </div>
                <input type="range" min={30} max={500} step={10} value={priceNight}
                  onChange={e => setPriceNight(+e.target.value)}
                  style={{ width: '100%', accentColor: '#1D9E75', cursor: 'pointer' }} />
                <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: 10, color: 'var(--ink-4)', marginTop: 2 }}>
                  <span>30€</span><span>500€</span>
                </div>
              </div>
              <div>
                <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: 12, marginBottom: 5 }}>
                  <span style={{ color: 'var(--ink-3)' }}>Nuits louees / mois</span>
                  <span style={{ fontWeight: 500, color: 'var(--ink)' }}>{nights} nuits</span>
                </div>
                <input type="range" min={1} max={30} step={1} value={nights}
                  onChange={e => setNights(+e.target.value)}
                  style={{ width: '100%', accentColor: '#1D9E75', cursor: 'pointer' }} />
                <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: 10, color: 'var(--ink-4)', marginTop: 2 }}>
                  <span>1 nuit</span><span>30 nuits</span>
                </div>
              </div>
            </div>

            <div style={{ border: '1px solid var(--border)', borderRadius: 12, overflow: 'hidden', marginBottom: 16 }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', padding: '9px 14px', fontSize: 13, borderBottom: '1px solid var(--border)', background: 'var(--white)' }}>
                <span style={{ color: 'var(--ink-3)' }}>Revenus bruts</span>
                <span style={{ fontWeight: 500, color: 'var(--ink)' }}>{base.toLocaleString('fr-FR')} €</span>
              </div>
              <div style={{ display: 'flex', justifyContent: 'space-between', padding: '9px 14px', fontSize: 13, borderBottom: '1px solid var(--border)', background: 'var(--surface)' }}>
                <span style={{ color: 'var(--ink-3)' }}>Commission Airbnb (15,5%)</span>
                <span style={{ fontWeight: 500, color: '#A32D2D' }}>-{airbnb.toLocaleString('fr-FR')} €</span>
              </div>
              <div style={{ display: 'flex', justifyContent: 'space-between', padding: '9px 14px', fontSize: 13, background: 'var(--white)' }}>
                <span style={{ color: 'var(--ink-3)' }}>Commission Havenly (8%)</span>
                <span style={{ fontWeight: 500, color: '#1D9E75' }}>-{havenly.toLocaleString('fr-FR')} €</span>
              </div>
            </div>

            <div style={{ background: '#E1F5EE', border: '1px solid #9FE1CB', borderRadius: 12, padding: '12px 16px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 20 }}>
              <div>
                <div style={{ fontSize: 13, fontWeight: 500, color: '#0F6E56' }}>Vous gagneriez en plus</div>
                <div style={{ fontSize: 11, color: '#0F6E56', opacity: 0.7, marginTop: 2 }}>chaque mois avec Havenly</div>
              </div>
              <div style={{ fontFamily: 'var(--serif)', fontSize: 26, fontWeight: 500, color: '#1D9E75' }}>+{gain.toLocaleString('fr-FR')} €</div>
            </div>

            <div style={{ height: 1, background: 'var(--border)', marginBottom: 16 }} />

            <div style={{ marginBottom: 12 }}>
              <label style={{ fontSize: 12, fontWeight: 500, color: 'var(--ink-3)', display: 'block', marginBottom: 6 }}>
                Pourquoi vous partez ? <span style={{ fontWeight: 400 }}>(optionnel)</span>
              </label>
              <textarea value={reason} onChange={e => setReason(e.target.value)}
                placeholder="Un tarif trop eleve, un manque d'informations, pas encore pret..."
                style={{ width: '100%', padding: '10px 12px', border: '1px solid var(--border)', borderRadius: 10, fontSize: 13, fontFamily: 'var(--sans)', resize: 'vertical', minHeight: 70, outline: 'none', boxSizing: 'border-box', color: 'var(--ink)', lineHeight: 1.6 }}
                onFocus={e => e.target.style.borderColor = 'var(--green)'}
                onBlur={e => e.target.style.borderColor = 'var(--border)'} />
            </div>

            <div style={{ marginBottom: 16 }}>
              <label style={{ fontSize: 12, fontWeight: 500, color: 'var(--ink-3)', display: 'block', marginBottom: 6 }}>
                Votre email <span style={{ fontWeight: 400 }}>(pour etre recontacte)</span>
              </label>
              <input type="email" value={email} onChange={e => setEmail(e.target.value)}
                placeholder="marie@exemple.fr"
                style={{ width: '100%', padding: '10px 14px', border: '1px solid var(--border)', borderRadius: 10, fontSize: 13, fontFamily: 'var(--sans)', outline: 'none', boxSizing: 'border-box', color: 'var(--ink)' }}
                onFocus={e => e.target.style.borderColor = 'var(--green)'}
                onBlur={e => e.target.style.borderColor = 'var(--border)'} />
            </div>

            <button onClick={handleSubmit} disabled={loading}
              style={{ width: '100%', padding: '13px', background: loading ? '#9FE1CB' : 'var(--green)', color: '#fff', border: 'none', borderRadius: 10, fontSize: 14, fontWeight: 500, cursor: loading ? 'not-allowed' : 'pointer', fontFamily: 'var(--sans)', marginBottom: 8 }}>
              {loading ? 'Envoi...' : 'Rejoindre Havenly et gagner +' + gain.toLocaleString('fr-FR') + ' euros/mois'}
            </button>
            <button onClick={handleDismiss}
              style={{ width: '100%', padding: '10px', background: 'transparent', border: 'none', fontSize: 12, color: 'var(--ink-4)', cursor: 'pointer', fontFamily: 'var(--sans)' }}>
              Continuer a perdre {gain.toLocaleString('fr-FR')} euros/mois
            </button>

          </div>
        )}
      </div>
    </>
  );
} 